import request from '@/utils/request'

/**
 * 庭审相关API接口
 */

/**
 * 创建庭审
 * @param {Object} data 庭审数据
 * @returns {Promise}
 */
export function createHearing(data) {
  return request.post('/api/hearing/createHearing', data)
}

/**
 * 编辑庭审
 * @param {string} hearingId 庭审ID
 * @param {Object} data 庭审数据
 * @returns {Promise}
 */
export function editHearing(hearingId, data) {
  return request.put(`/api/hearing/edit/${hearingId}`, data)
}

/**
 * 删除庭审
 * @param {string} hearingId 庭审ID
 * @returns {Promise}
 */
export function deleteHearing(hearingId) {
  return request.delete(`/api/hearing/${hearingId}`)
}

/**
 * 根据案件ID查询庭审列表
 * @param {string} caseId 案件ID
 * @returns {Promise}
 */
export function getHearingsByCaseId(caseId) {
  return request.get('/api/hearing/listByCaseId', { params: { caseId } })
}

/**
 * 开庭
 * @param {string} hearingId 庭审ID
 * @returns {Promise}
 */
export function startHearing(hearingId) {
  return request.post(`/api/hearing/start/${hearingId}`)
}

/**
 * 预备开庭
 * @param {string} hearingId 庭审ID
 * @returns {Promise}
 */
export function prepareHearing(hearingId) {
  return request.post(`/api/hearing/prepare/${hearingId}`)
}

/**
 * 休庭
 * @param {string} hearingId 庭审ID
 * @returns {Promise}
 */
export function pauseHearing(hearingId) {
  return request.post(`/api/hearing/pause/${hearingId}`)
}

/**
 * 恢复庭审
 * @param {string} hearingId 庭审ID
 * @returns {Promise}
 */
export function resumeHearing(hearingId) {
  return request.post(`/api/hearing/resume/${hearingId}`)
}

/**
 * 闭庭
 * @param {string} hearingId 庭审ID
 * @returns {Promise}
 */
export function closeHearing(hearingId) {
  return request.post(`/api/hearing/close/${hearingId}`)
}

/**
 * 获取庭审详情
 * @param {string} hearingId 庭审ID
 * @returns {Promise}
 */
export function getHearingDetail(hearingId) {
  return request.get(`/api/hearing/getHearingById/${hearingId}`)
}

/**
 * 获取庭审所有参会人
 * @param {string} hearingId 庭审ID
 * @returns {Promise}
 */
export function getHearingParticipants(hearingId) {
  return request.get(`/api/hearing/allParticipants/${hearingId}`)
}
